import * as qs from "query-string";

export const getQueryStringValue = (
  key,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString);
  return values[key];
};

export const setQueryStringValue = (
  key,
  value,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({ ...values, [key]: value });
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

export const setQueryStringWithoutPageReload = (qsValue) => {
  const newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    qsValue;

  window.history.pushState({ path: newurl }, "", newurl);
};

export const clearQueryStrings = () => {
  const values = qs.parse(window.location.search);
  let newQsValue = '';
  if (values.app) {
    newQsValue = qs.stringify({ app: values.app });
  }
  setQueryStringWithoutPageReload(`?${newQsValue}`);
}
